module.exports = __webpack_public_path__ + "static/media/sub-card-label-2.c724c070.svg";